import assign from '@ali/xutil/assign';
import each from '@ali/xutil/each';
import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import isFunction from 'lodash/isFunction';
import Context from './context';

let AsyncInvokers = {
  // type: invoker
};

let SyncInvokers = {
  // type: invoker
};

let settings = {
  api: {
    /**
     * alias: {type: 'ajax', uri: '//api.com/get-something/'}
     */
  },
};

let Core = {

  setup(options) {
    assign.deep(settings, options);
    return this
  },

  call(options) {
    /**
     * api info
     * @type {Object}
     * @type {String} api.type       API 类型
     * @type {String} api.alias      API 别名
     * @type {String} api.uri        API 识别标志
     * @type {Array}  api.routes     API 请求路径
     */
    let {api} = options;

    options.__X__ = this;
    let Invokers = api.sync ? SyncInvokers : AsyncInvokers;
    let Invoker = Invokers[api.type];
    let invokerInstace = new Invoker(options);

    return invokerInstace.call();
  },

  getApiByAlias(alias) {
    /**
     * api info
     * @type {Object}
     * @type {String} api.type       API 类型
     * @type {String} api.alias      API 别名
     * @type {String} api.uri        API 识别标志
     * @type {Array}  api.routes     API 请求路线
     */
    let api = settings.api[alias] || null;
    if (api) {
      api = assign({alias}, api);
    }
    return api;
  },

  addInvoker(Invoker) {
    let Invokers = Invoker.sync ? SyncInvokers : AsyncInvokers;
    Invokers[Invoker.type] = Invoker;
    return this;
  },

  getSyncInvoker(type) {
    return SyncInvokers[type] || null;
  },

  getAsyncInvoker(type) {
    return AsyncInvokers[type] || null;
  },

  // 插件扩展接口
  plug(name, plugin) {
    let Core = this;
    // 多个 plugin 的 map 形式
    function plug(plugin, name) {
      if (Core[name]) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn(`SDK plugin ${name} already exists.`);
        }
        return;
      }
      let pluginReturn = isFunction(plugin) ? plugin(Core) : plugin;
      if (pluginReturn) {
        Core[name] = pluginReturn;
      }
    }
    if (isObject(name)) {
      each(name, plug);
    } else {
      plug(plugin, name);
    }
    return this;
  },
};

export default Core;



// WEBPACK FOOTER //
// ../x/packages/core/src/core.js